import { memo } from 'react';

export const WorkspaceSidebarLibrariesListItemSkeleton = memo(() => {
  return (
    <div className="flex h-10 w-full cursor-progress items-center gap-3 px-2">
      <div className="size-6 shrink-0 rounded-4 bg-grey-5" />
      <div className="h-5 w-full rounded-4 bg-grey-5" />
    </div>
  );
});

WorkspaceSidebarLibrariesListItemSkeleton.displayName = 'WorkspaceSidebarLibrariesListItemSkeleton';
